// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { put, call, takeLatest, takeEvery } from 'redux-saga/effects';
import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

import UserInfoDal from './../../../dal/UserInfoDal';
import {
    GET_SOLD_TO_LIST,
    getSoldToListSuccess,
    GET_SHIP_TO_LIST,
    getShipToListSuccess,
    POST_SOLD_TO_SHIP_TO,
    postSoldToShipToSuccess,
    CLEAR_SOLD_TO_SHIP_TO_MESSAGE,
    GET_ONSITE_SOLD_TO_SHIP_TO,
    getOnsiteSoldToShipToSuccess,
} from './../../../store/managePartners';

export function* getAllSoldToList(): IterableIterator<any> {
    try {
        yield put(actionStatusStarted({ actionName: GET_SOLD_TO_LIST }));
        const response = yield call(UserInfoDal.getSoldToList);
        yield put(getSoldToListSuccess(response));
        yield put(actionStatusSuccess({ actionName: GET_SOLD_TO_LIST }));
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: GET_SOLD_TO_LIST,
                error: e,
            })
        );
    }
}

export function* getOnSiteSoldTo(): IterableIterator<any> {
    try {
        yield put(actionStatusStarted({ actionName: GET_ONSITE_SOLD_TO_SHIP_TO }));
        const response = yield call(UserInfoDal.getOnSiteSoldToShipToList);
        yield put(getOnsiteSoldToShipToSuccess(response));
        yield put(actionStatusSuccess({ actionName: GET_ONSITE_SOLD_TO_SHIP_TO }));
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: GET_ONSITE_SOLD_TO_SHIP_TO,
                error: e,
            })
        );
    }
}

export function* getAllShipToList(): IterableIterator<any> {
    try {
        yield put(actionStatusStarted({ actionName: GET_SHIP_TO_LIST }));
        const response = yield call(UserInfoDal.getShipToList);
        yield put(getShipToListSuccess(response));
        yield put(actionStatusSuccess({ actionName: GET_SHIP_TO_LIST }));
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: GET_SHIP_TO_LIST,
                error: e,
            })
        );
    }
}

export function* postSoldToShipTo(request: any): IterableIterator<any> {
    try {
        yield put(actionStatusStarted({ actionName: POST_SOLD_TO_SHIP_TO }));
        const response = yield call(UserInfoDal.manageSoldToShipTo, request);
        yield put(postSoldToShipToSuccess(response));
        yield put(actionStatusSuccess({ actionName: POST_SOLD_TO_SHIP_TO }));
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: POST_SOLD_TO_SHIP_TO,
                error: e,
            })
        );
    }
}

function* clearMessage(): IterableIterator<any> {
    try {
        yield put(actionStatusStarted({ actionName: CLEAR_SOLD_TO_SHIP_TO_MESSAGE }));
        yield put(postSoldToShipToSuccess(''));
        yield put(actionStatusSuccess({ actionName: CLEAR_SOLD_TO_SHIP_TO_MESSAGE }));
    } catch (e) {
        actionStatusFailed({
            actionName: CLEAR_SOLD_TO_SHIP_TO_MESSAGE,
            error: e,
        });
    }
}

export default [
    takeLatest(`${GET_SOLD_TO_LIST}`, getAllSoldToList),
    takeLatest(`${GET_SHIP_TO_LIST}`, getAllShipToList),
    takeEvery(`${POST_SOLD_TO_SHIP_TO}`, postSoldToShipTo),
    takeEvery(`${CLEAR_SOLD_TO_SHIP_TO_MESSAGE}`, clearMessage),
    takeLatest(`${GET_ONSITE_SOLD_TO_SHIP_TO}`, getOnSiteSoldTo),
];
